import { z } from "zod"

import {
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

const request = z.object({
  requestVersion: z.literal(1),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  expectedVersion: z.number().int().positive(),
}).strict()

export const depositAttemptStateV1Schema = z.enum([
  "processing",
  "succeeded",
  "failed",
  "reconciliation_required",
])

export const estimateDepositBeginV1Schema = request.extend({
  depositAttemptId: entityIdSchema,
  estimateId: entityIdSchema,
  revisionId: entityIdSchema,
  contactId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  actionTokenHash: z.string().regex(/^[a-f0-9]{64}$/),
  occurredAt: z.string().datetime({ offset: true }),
}).strict()

export const estimateDepositSessionV1Schema = z.object({
  depositAttemptId: entityIdSchema,
  estimateId: entityIdSchema,
  revisionId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  state: z.literal("processing"),
  amountMinor: z.number().int().positive(),
  currency: z.string().regex(/^[a-z]{3}$/),
  checkoutSessionId: z.string().regex(/^cs_test_[A-Za-z0-9_]{8,128}$/),
  checkoutUrl: z.string().url().refine(
    (value) => new URL(value).hostname === "checkout.stripe.com",
    "Checkout URL must use Stripe Checkout."
  ),
  expiresAt: z.string().datetime({ offset: true }),
}).strict()

export const paymentReconciliationResolveV1Schema = request.extend({
  reconciliationId: entityIdSchema,
  depositAttemptId: entityIdSchema,
  resolution: z.literal("match_existing_attempt"),
}).strict()

export const customerPaymentWebhookResultV1Schema = z.object({
  resultVersion: z.literal(1),
  status: z.enum(["processed", "duplicate", "reconciliation_required", "ignored"]),
  eventRef: z.string().regex(/^[a-f0-9]{16}$/),
}).strict()

export type EstimateDepositBeginV1 = z.infer<typeof estimateDepositBeginV1Schema>
export type EstimateDepositSessionV1 = z.infer<typeof estimateDepositSessionV1Schema>
export type PaymentReconciliationResolveV1 = z.infer<
  typeof paymentReconciliationResolveV1Schema
>
export type CustomerPaymentWebhookResultV1 = z.infer<
  typeof customerPaymentWebhookResultV1Schema
>
